import React from 'react'
import {
  SavedConfigWrapper,
  Title,
  Number,
  ContentWrapper,
} from '../../../AutoConfigStyles'
import DoubleRedDice from '../dice/DoubleRedDice'
import DoubleBlueDice from '../dice/DoubleBlueDice'
interface Saved_config_porps {
  title: string
  emptyConfig: boolean
  rollUnder?: any
  number?: string
  id: number
  handleConfig: any
  isActive: boolean
}

export default function SavedConfig({
  title,
  emptyConfig,
  rollUnder,
  number,
  id,
  handleConfig,
  isActive,
}: Saved_config_porps) {
  return (
    <SavedConfigWrapper
      emptyConfig={emptyConfig}
      rollUnder={rollUnder}
      isActive={isActive}
    >
      {emptyConfig ? (
        title
      ) : (
        <ContentWrapper onClick={() => handleConfig(id)}>
          <div>
            <Title rollUnder={rollUnder}>{title}</Title>
            <Number>
              {!rollUnder ? '<' : '>'} {number}.00
            </Number>
          </div>
          {!rollUnder ? <DoubleRedDice /> : <DoubleBlueDice />}
        </ContentWrapper>
      )}
    </SavedConfigWrapper>
  )
}
